<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { useWebViewStore } from '@nora-monorepo/ui-shared';

import MapAttributions from '#nora-ui/map/components/controls/map-info/MapAttributions.vue';
import MapCoordinates from '#nora-ui/map/components/controls/map-info/MapCoordinates.vue';
import MapScaleLine from '#nora-ui/map/components/controls/map-info/MapScaleLine.vue';
import { useMapStore } from '#nora-ui/map/stores/map-store';

interface MapInfoProps {
  mapId: string;
}

const props = defineProps<MapInfoProps>();

const mapStore = useMapStore();
const webViewStore = useWebViewStore();

const map = mapStore.getMapByIdOrThrow(props.mapId);
const { isWebView } = storeToRefs(webViewStore);

const showCoordinates = computed(() => {
  // Coordinates are alawys shown outside webView
  if (!isWebView.value) {
    return map.ref.hasVisibleCoordinateSystems();
  }

  // When in webView, we hide coordinates while draw tools are active
  if (map.drawToolUI.isToolListOpen.value) {
    return false;
  }

  if (map.drawToolUI.activeDrawTool.value !== null) {
    return false;
  }

  return map.ref.hasVisibleCoordinateSystems();
});
</script>

<template>
  <div
    class="absolute bottom-4 right-4 flex flex-col gap-2 items-end pointer-events-none select-none"
  >
    <MapCoordinates
      v-if="showCoordinates"
      :map-id="mapId"
    />

    <MapScaleLine
      v-if="map.ref.isScaleLineVisible"
      :map-id="mapId"
    />
    <MapAttributions :map-id="mapId" />
  </div>
</template>
